<script setup>
import { Head, Link, router, useForm, usePage } from '@inertiajs/vue3'
import {
    onMounted,
    onBeforeUnmount,
    onUnmounted,
    ref,
    isProxy,
    toRaw,
    onBeforeMount,
} from 'vue'
import { computed } from 'vue'
import { initFlowbite } from 'flowbite'
// import ReportModal from '@/Components/main-components/ReportModal.vue'

let unsubscribeRouter = null

const initializeModal = () => {
    initFlowbite()
}

onMounted(() => {
    initializeModal()

    // Listen for Inertia navigation events to re-initialize Flowbite
    unsubscribeRouter = router.on('navigate', () => {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
            initializeModal()
        }, 100)
    })
})

onUnmounted(() => {
    // Clean up router listener
    if (unsubscribeRouter) {
        unsubscribeRouter()
    }
})

const baseUrl = window.location.href // Replace with your base URL

// Compute the full video URL
const videoUrl = computed(() => {
    return baseUrl
})
const generateVideoUrl = ref(window.location.href)

const showCopiedTip = ref(false)

const copyToClipboard = () => {
    generateVideoUrl.value = window.location.href
    const el = document.createElement('textarea')
    el.value = generateVideoUrl.value
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)

    // Show the "Copied" tip
    showCopiedTip.value = true

    // Hide the "Copied" tip after a delay (e.g., 3 seconds)
    setTimeout(() => {
        showCopiedTip.value = false
    }, 2000)
}

const shareOnTwitter = () => {
    // Construct the Twitter share URL with your videoUrl
    const tweetUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        videoUrl.value,
    )}`

    // Open the Twitter sharing dialog in a new window or tab
    window.open(tweetUrl, '_blank')
}
const shareOnReddit = () => {
    // Construct the Reddit share URL with your videoUrl
    const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(videoUrl.value)}`

    // Open the Reddit sharing dialog in a new window or tab
    window.open(redditUrl, '_blank')
}
const shareOnWhatsApp = () => {
    // Construct the WhatsApp share URL with your videoUrl
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        videoUrl.value,
    )}`

    // Open the WhatsApp sharing dialog in a new window or tab
    window.open(whatsappUrl, '_blank')
}
const shareOnTelegram = () => {
    // Construct the Telegram share URL with your videoUrl
    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(videoUrl.value)}`

    // Open the Telegram sharing dialog in a new window or tab
    window.open(telegramUrl, '_blank')
}

const shareViaSMS = () => {
    // Construct the SMS message with your videoUrl
    const smsMessage = `Check out this Extra Naughty ${type}: ${videoUrl.value}`

    // Open the user's default SMS application with the message pre-filled
    window.location.href = `sms:&body=${encodeURIComponent(smsMessage)}`
}
const formReport = useForm({
    reason: '',
    message: '',
})
const { report, urlID, type } = defineProps(['report', 'urlID', 'type'])
const showReportModal = ref(false)
const openReportModal = () => {
    showReportModal.value = true
}

const closeReportModal = () => {
    showReportModal.value = false
    formReport.reset()
}
</script>

<template>
    <Teleport to="body">
        <div
            id="ShareLinkModal"
            tabindex="-1"
            class="fixed left-0 right-0 top-0 z-50 hidden h-[calc(100%)] max-h-full overflow-x-hidden overflow-y-hidden p-4 md:inset-0">
            <div
                class="absolute bottom-[45px] max-h-full w-[98%] max-w-md rounded-lg bg-white sm:relative sm:w-full">
                <div
                    class="flex items-start justify-between rounded-t border-b px-[22px] py-4 dark:border-0">
                    <h3
                        class="text-[16px] font-semibold leading-[30px] text-gray-900 dark:text-black">
                        Share
                    </h3>
                    <div class="ml-auto flex items-center space-x-2">
<!--                        <button-->
<!--                            v-if="report"-->
<!--                            data-modal-hide="ShareLinkModal"-->
<!--                            @click="openReportModal"-->
<!--                            class="btn-report flex w-[78px] cursor-pointer items-center justify-center rounded-[6px] border border-gray-400 px-4 text-center text-[12px] leading-[29px] text-black hover:bg-gray-400 dark:text-black dark:hover:text-white">-->
<!--                            <font-awesome-icon class="pr-[6px]" :icon="['fas', 'flag']" />-->
<!--                            <span>Report</span>-->
<!--                        </button>-->
                        <button
                            type="button"
                            class="btn-close-modal text-black"
                            data-modal-hide="ShareLinkModal">
                            <svg
                                class="h-5 w-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <span class="sr-only">Close modal</span>
                        </button>
                    </div>
                </div>
                <!-- Modal body -->
                <div class="space-y-6 p-6">
                    <div
                        id="social-icons"
                        class="flex justify-center gap-[20px] font-semibold text-gray-900 dark:text-black">
                        <div
                            alt="Share on SMS"
                            title="Share on SMS"
                            @click="shareViaSMS"
                            class="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full bg-smsgreen">
                            <font-awesome-icon
                                class="text-[32px] text-white"
                                :icon="['fas', 'comment-sms']" />
                        </div>

                        <div
                            @click="shareOnTwitter"
                            alt="Share on Twitter"
                            title="Share on Twitter"
                            class="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full bg-xblack">
                            <font-awesome-icon
                                icon="fa-brands fa-x-twitter"
                                class="text-[32px] text-white" />
                        </div>
                        <div
                            @click="shareOnReddit"
                            alt="Share on Reddit"
                            title="Share on Reddit"
                            class="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full bg-redditred">
                            <font-awesome-icon
                                class="text-[32px] text-white"
                                :icon="['fab', 'reddit']" />
                        </div>
                        <div
                            @click="shareOnWhatsApp"
                            alt="Share on WhatsApp"
                            title="Share on WhatsApp"
                            class="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full bg-whatsappgreen">
                            <font-awesome-icon
                                class="text-[32px] text-white"
                                :icon="['fab', 'whatsapp']" />
                        </div>
                        <div
                            alt="Share on Telegram"
                            title="Share on Telegram"
                            @click="shareOnTelegram"
                            class="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full bg-telegramblue">
                            <font-awesome-icon
                                class="text-[32px] text-white"
                                :icon="['fab', 'telegram']" />
                        </div>
                    </div>
                    <div class="relative">
                        <input
                            type="text"
                            :value="videoUrl"
                            class="w-full rounded-lg border border-gray-500 p-3 text-black dark:border-gray-600 dark:bg-gray-200 dark:text-black"
                            readonly />
                        <button
                            @click="copyToClipboard"
                            alt="Copy to Clipboard"
                            title="Copy to Clipboard"
                            type="button"
                            class="absolute right-[1px] top-[5px] rounded-lg bg-gray-200 px-5 py-2.5 text-center text-sm font-medium text-black focus:outline-none focus:ring-4 focus:ring-blue-300">
                            <font-awesome-icon
                                class="text-[20px] text-gray-500"
                                :icon="['fas', 'copy']" />
                        </button>
                        <!-- Copied Tip -->
                        <div
                            class="absolute -top-6 right-0 rounded-full bg-green-500 px-2 py-1 text-xs text-white opacity-[100%]"
                            v-show="showCopiedTip">
                            Copied
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
<!--    <ReportModal-->
<!--        :type="type"-->
<!--        :show="showReportModal"-->
<!--        @close="closeReportModal"-->
<!--        :closeable="true"-->
<!--        :urlID="urlID" />-->
</template>
